export default "__VITE_ASSET__CtAr8lEb__"